import { ContextStore } from 'bernie-core';
import { Logger } from 'bernie-logger';
import { bffFetch, Headers } from './bff-fetch';

export class RateCalendarApiSource {
  private host: string;
  private logger: Logger;
  private forwardedHeaders: Headers;

  constructor(host = '', logger, forwardedHeaders: Headers = {}) {
    this.host = host;
    this.logger = logger;
    this.forwardedHeaders = forwardedHeaders;
  }

  public fetchHIS(context: ContextStore, criteria: any, hotelId: number) {
    if (context && criteria && hotelId) {
      return bffFetch(this.host, `rate-calendar/hotel/${hotelId}`, context, criteria, this.logger, this.forwardedHeaders);
    }
  }

  public fetchHSR(context: ContextStore, criteria: any, regionId: number) {
    if (context && criteria && regionId) {
      return bffFetch(this.host, `rate-calendar/region/${regionId}`, context, criteria, this.logger, this.forwardedHeaders);
    }
  }
}
